import { $Q, $Qll } from "graditify-utils";
import { isActive, toggleDataActive } from "../src/utils/toggle-dataset";

/**
 *
 * @param {String} id - ID from node manipulate
 * @param {Boolean} active - If modal active
 * @param {HTMLElement} node - Node to manipulate
 */
const overlayActions = (id, active, node, noScroll) => {
  const idOverlay = `overlay--${id}`;
  const parent = node.parentNode;

  if (!active) {
    // eslint-disable-next-line no-undef
    const overlay = document.createElement("div");

    overlay.setAttribute("id", idOverlay);
    overlay.classList.add("overlay");
    document.body.style.overflow = 'hidden';

    parent.insertBefore(overlay, node);
    // eslint-disable-next-line no-use-before-define
  toggleDataActive(`#${idOverlay}`, `#${id}`, {
      overlay: true,
      blockScroll: noScroll,
    });
  } else {
    parent.removeChild($Q(`#${idOverlay}`));
    document.body.style.overflow = 'initial';
  }
}

function dataToggle(node, overlay) {
  const { dataset, id } = node;
  const active = isActive(dataset);
  const nav = $Q("#nav-list-movil-js");
  const body = $Q("body")

  if (active) {
    nav.style.animation = "closewindow 0.3s ease";
    setTimeout(() => {
      dataset.active = "false";
      nav.style.animation = "slidewindow 0.3s ease";
    }, 300);
  } else {
    body.style.overflow = "hidden";
    dataset.active = "true";
  }

  // eslint-disable-next-line no-unused-expressions
  overlay && overlayActions(id, active, node, true);
}

const toggleNavMenu = (control, node, config = {}) => {
  const header = $Q('.header-absoluted');
  let trigger = control;

  if (typeof control === 'string') {
    trigger = $Q(control);
  }

  if (!trigger) return;

  const { overlay, closeSelector, cb } = config;

  trigger.addEventListener('click', () => {
    dataToggle($Q(node), overlay, cb);
    const active = isActive($Q(node).dataset);
    if (active) {
      header.classList.add('header-fixed');
    } else {
      header.classList.remove('header-fixed');
    }
  });

  if (closeSelector) {
    $Q(closeSelector).addEventListener('click', () => {
      dataToggle($Q(node), overlay);
      header.classList.remove('header-fixed');
    });
  }
};

/**
 * Init resource windows
 * @param {{ control: string, target: string }} params - Init parametres
 * @param {String} params.control - Reference controller the open modal window
 * @param {String} params.target - Reference of the modal window
 */
const initWindows = ({ control, target }) => {
  windowsToggle(target);

  toggleNavMenu(
    control,
    target,
    {
      overlay: true,
      closeSelector: '.window-close-js',
    },
  );
}

/**
 * Action on click item window
 *
 * @param {HTMLElement} scope - scope or parent target
 */
const windowsToggle = (scope) => {
  const parentNode = $Q(scope);
  const itemToggle = $Qll('.window-item-js', parentNode);
  const layerItems = $Qll('.window-layer-close-js', parentNode)

  itemToggle.forEach((item) => item.addEventListener('click',
    () => {
      item.setAttribute('data-active', 'true');
    },
  ))

  layerItems.forEach((layeritem) => {
    layeritem.addEventListener('click', () => {
      const layer = layeritem.closest('.window-layer-js');
      if (!layer) return null;
      const sibling = layer.previousElementSibling;
      layer.style.animation = "closewindow 0.3s ease";
      setTimeout(() => {
        sibling.setAttribute('data-active', 'false');
        layer.style.animation = "slidewindow 0.3s ease";
      }, 300);
    });
  })
}

export default initWindows;
